import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, FileText, Star, Users, MapPin, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './Shared';
export function Hero() {
  return <section className="relative bg-brand-950 text-white overflow-hidden min-h-[100svh] md:min-h-0 pt-2 pb-6 md:pt-12 md:pb-20 lg:pt-20 lg:pb-28" data-id="element-84">
      {/* Background Accents */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-sky-400 via-white to-sky-400 opacity-20" data-id="element-85"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-800 rounded-full blur-3xl opacity-50" data-id="element-86"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-87">
        <div className="max-w-3xl mx-auto" data-id="element-88">
          {/* Single Column: Copy with image inline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-4 md:space-y-8" data-id="element-89">
            <div className="inline-flex items-center gap-2 bg-brand-900/50 border border-brand-800 rounded-full px-4 py-1.5 text-xs md:text-sm font-medium text-sky-300 self-start" data-id="element-90">
              TODO TU AÑO DE CIUDADANIA RESUELTO.
            </div>

            <div className="space-y-2 md:space-y-4" data-id="element-91">
              <h1 className="text-4xl sm:text-5xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] md:leading-tight" data-id="element-92">
                TODO TU AÑO DE{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-200" data-id="element-93">
                  CIUDADANÍA
                </span>{' '}
                RESUELTO.
              </h1>
              <h2 className="text-base md:text-2xl text-slate-300 font-medium leading-snug md:leading-relaxed" data-id="element-94">
                MegaPack Ciudadanía 360 — 12 tomos completos para docentes de
                Construcción de Ciudadanía de 1° a 3° año de secundaria
              </h2>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative w-full max-w-[260px] sm:max-w-xs md:max-w-lg mx-auto py-2 md:py-4" data-id="element-95">
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-600 to-sky-400 rounded-2xl blur-2xl opacity-20 transform rotate-3" data-id="element-96"></div>
              <div className="relative bg-white p-2 md:p-3 rounded-xl md:rounded-2xl shadow-2xl border border-white/10" data-id="element-97">
                <img src="https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&q=80&w=800" alt="MegaPack Ciudadanía 360 - Materiales para docentes" className="w-full h-auto rounded-lg md:rounded-xl object-cover aspect-[4/5]" data-id="element-98" />
                <div className="absolute top-2 -right-3 md:top-6 md:-right-6 bg-amber-500 text-white font-bold py-1 px-2 md:py-2 md:px-4 text-xs md:text-base rounded md:rounded-lg shadow-lg transform rotate-6" data-id="element-99">
                  ¡12 TOMOS!
                </div>
              </div>
            </motion.div>

            <p className="hidden md:block text-lg text-slate-400 leading-relaxed" data-id="element-100">
              +180 recursos de Ciudadanía creados para docentes que están hartos
              de improvisar. Actividades, debates y fichas listas para el aula,
              alineados al currículo argentino 2026.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-3 text-xs md:text-sm font-medium text-slate-300" data-id="element-101">
              <span className="flex items-center gap-1.5 bg-brand-900/40 px-3 py-1 rounded-md" data-id="element-102">
                <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-sky-400" data-id="element-103" />{' '}
                100% PDF
              </span>
              <span className="flex items-center gap-1.5 bg-brand-900/40 px-3 py-1 rounded-md" data-id="element-104">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-400" data-id="element-105" />{' '}
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5 bg-brand-900/40 px-3 py-1 rounded-md" data-id="element-106">
                <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4 text-sky-400" data-id="element-107" /> 🇦🇷
                Currículo 2026
              </span>
            </div>

            <div className="pt-2 md:pt-4 space-y-3 md:space-y-4" data-id="element-108">
              <CTAButton className="w-full md:w-auto text-base md:text-lg py-4 md:py-5 px-6 md:px-10" data-id="element-109">
                📚 → QUIERO MI CIUDADANÍA PACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center gap-4 text-sm text-slate-400" data-id="element-110">
                <span className="flex items-center gap-1" data-id="element-111">
                  <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-112" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-113">
                  <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-114" /> Pago
                  seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-115">
                  <Zap className="w-4 h-4 text-sky-400" data-id="element-116" /> Mercado Pago
                </span>
              </div>
            </div>

            <div className="hidden md:grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-brand-800/50" data-id="element-117">
              <div data-id="element-118">
                <div className="text-xl font-bold text-white" data-id="element-119">+1.200</div>
                <div className="text-xs text-slate-400 uppercase tracking-wider mt-1" data-id="element-120">
                  Docentes | Todo el país
                </div>
              </div>
              <div data-id="element-121">
                <div className="text-xl font-bold text-white" data-id="element-122">12 Tomos</div>
                <div className="text-xs text-slate-400 uppercase tracking-wider mt-1" data-id="element-123">
                  Listos para usar
                </div>
              </div>
              <div data-id="element-124">
                <div className="text-xl font-bold text-white flex items-center gap-1" data-id="element-125">
                  4.9/5{' '}
                  <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-126" />
                </div>
                <div className="text-xs text-slate-400 uppercase tracking-wider mt-1" data-id="element-127">
                  Calificación
                </div>
              </div>
              <div data-id="element-128">
                <div className="text-xl font-bold text-white" data-id="element-129">🇦🇷</div>
                <div className="text-xs text-slate-400 uppercase tracking-wider mt-1" data-id="element-130">
                  Todo el país | Secundaria
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}
export function TestimonialsHero() {
  const testimonials = [{
    quote: 'En una sola tarde dejé armado todo el año de Ciudadanía. Me liberó cabeza para enfocarme en los pibes.',
    name: 'SV — SOFÍA V.',
    location: 'MENDOZA | SECUNDARIA'
  }, {
    quote: 'Los chicos de 2° año pasaron de mirar el celular a discutir con fundamentos. Las actividades los atrapan al toque.',
    name: 'DA — DIEGO A.',
    location: 'LA PLATA | SECUNDARIA'
  }, {
    quote: 'Llevé la planificación anual, ESI y EAI el primer día de clases. La directora pensó que había trabajado todo el verano.',
    name: 'CB — CAROLINA B.',
    location: 'SALTA | SECUNDARIA'
  }];
  return <section className="bg-brand-900 py-12 border-b border-brand-800" data-id="element-131">
      <div className="container mx-auto px-4" data-id="element-132">
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-133">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-950/50 border border-brand-800/50 p-6 rounded-xl" data-id="element-134">
              <div className="flex gap-1 mb-4" data-id="element-135">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-136" />)}
              </div>
              <p className="text-slate-300 text-sm md:text-base italic mb-6" data-id="element-137">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-138">
                <p className="text-white font-bold text-sm" data-id="element-139">{t.name}</p>
                <p className="text-brand-300 text-xs mt-0.5" data-id="element-140">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}